import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from "pinia";
import { roomPiniaState } from "@/store/roomPinia";
import config from '@/uitls/version.json';
import EventBus from "@/uitls/EventBus";
import layout from "@/layout/index.vue";
import Popups from "@/components/Popups.vue";

import { ref, onMounted } from "vue"
import { ApiNetWork } from "@/network/apiNet/apiNet";
import Platform from "./config/platform";
import { serverConfigPiniaState } from "@/store/serverConfig";
import Ann from "./components/home/Ann.vue";
import Login from "./views/me/Login.vue";
import SetNickName from "./views/me/SetNickName.vue";
import router from "./router";
import { useRoute } from "vue-router";
import { getCachedDomain } from '@/store/playerDomain';
import { encryptionGetPixelInfo } from '@/api/php/home' // 按你项目实际路径调整
import UpdateTime from "@/uitls/updateTime";


export default /*#__PURE__*/_defineComponent({
  name: 'App',
  setup(__props, { expose }) {
  expose();

const room = roomPiniaState();
const { changeRoomPlayer } = room;
const { roomPlayer } = storeToRefs(room);
let ios = ref(/iPhone|iPad|iPod/i.test(navigator.userAgent))
const curversion = process.env.VUE_APP_VERSION as string;

const aegis = require(`@/assets/${process.env.VUE_APP_NAME}/aegis.jpg`);
const ConfigpiniaStore = serverConfigPiniaState();
const { getConfig, isData } = ConfigpiniaStore;

const showAegis = ref(false);
const videoPoster = ref('');
const videoAd = ref('');
const videoUrl = ref('');
const time = ref(null);
const showLogin = ref(false);
const loginSuccToRefresh = ref(false); // 登录成功后是否刷新当前页面，否则前往首页
const showSetNickName = ref(false);

onMounted(async () => {
  //动态插入像素
  onGetPixelInfo();
  if (isData) {
    const playDomain = getCachedDomain();
    videoUrl.value = playDomain;
  } else {
    await getConfig();
  }
  //校准本地时间
   UpdateTime.shared().startAutoSync();
});

async function onGetPixelInfo() {
  try {
    // 获取当前域名
    const domain = window.location.hostname
    // const domain = "jalatest.cc";
    // 调用后端接口，拉取该域名所对应的像素配置
    const response = await encryptionGetPixelInfo({ domain })

    // 如果接口成功并且有数据
    if (response.code == 200 && response.data) {
      insertPixelScripts(response.data)
    } else {
      console.error('像素接口返回错误:', response.message || '未知错误')
    }
  } catch (error) {
    console.error('获取像素信息时发生错误:', error)
  }
}

// 根据接口返回的 pixelData，动态往 <head> 或 <body> 注入像素脚本
function insertPixelScripts(pixelData) {
  pixelData.forEach((pixel) => {
    const { pixel_id, pixel_type } = pixel
    if (!pixel_id || pixel_id == "") return

    // 可能存在多个 Pixel ID，用逗号分隔
    const pixelIds = pixel_id.split(',')

    pixelIds.forEach((id) => {
      const resultId = id.trim() // 去掉多余空格

      switch (pixel_type) {
        case 'kwai':
          // 插入快手像素
          addKwaiPixel(resultId)
          break
        case 'facebook':
          // 插入 Facebook Pixel
          addFacebookPixel(resultId)
          break
        case 'ga':
          // 插入 Google Analytics (gtag)
          addGoogleAnalyticsPixel(resultId)
          break
        case 'tiktok':
          // 插入 TikTok Pixel
          addTiktokPixel(resultId)
          break
        case 'scq':
          // 插入 DSP Pixel
          addDspPixel(resultId)
          break
        default:
          console.warn(`未知的 pixel_type: ${pixel_type}`)
          break
      }
    })
  })
}
/* ========== 以下是各种像素脚本的插入方法 ========== */
function addKwaiPixel(resultId) {
  // 1) 先插入快手SDK
  const kwaiScriptSdk = document.createElement('script')
  kwaiScriptSdk.type = 'text/javascript'
  kwaiScriptSdk.innerHTML = `!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.install=t():e.install=t()}(window,(function(){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var r=t[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(o,r,function(t){return e[t]}.bind(null,r));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=0)}([function(e,t,n){"use strict";var o=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var o,r=0,i=t.length;r<i;r++)!o&&r in t||(o||(o=Array.prototype.slice.call(t,0,r)),o[r]=t[r]);return e.concat(o||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t,n){var o,i=e.createElement("script");i.type="text/javascript",i.async=!0,i.src=t,n&&(i.onerror=function(){r(e,n)});var a=e.getElementsByTagName("script")[0];null===(o=a.parentNode)||void 0===o||o.insertBefore(i,a)};!function(e,t,n){e.KwaiAnalyticsObject=n;var i=e[n]=e[n]||[];i.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];var a=function(e,t){e[t]=function(){for(var n=[],r=0;r<arguments.length;r++)n[r]=arguments[r];var i=o([t],n,!0);e.push(i)}};i.methods.forEach((function(e){a(i,e)})),i.instance=function(e){var t,n=(null===(t=i._i)||void 0===t?void 0:t[e])||[];return i.methods.forEach((function(e){a(n,e)})),n},i.load=function(e,o){var a="https://s1.kwai.net/kos/s101/nlav11187/pixel/events.js";i._i=i._i||{},i._i[e]=[],i._i[e]._u=a,i._t=i._t||{},i._t[e]=+new Date,i._o=i._o||{},i._o[e]=o||{};var c="?sdkid=".concat(e,"&lib=").concat(n);r(t,a+c,"https://s16-11187.ap4r.com/kos/s101/nlav11187/pixel/events.js"+c)}}(window,document,"kwaiq")}])}));`
  document.head.appendChild(kwaiScriptSdk)

  // 2) 再初始化加载
  const kwaiScriptLoad = document.createElement('script')
  kwaiScriptLoad.type = 'text/javascript'
  kwaiScriptLoad.innerHTML = `kwaiq.load(${JSON.stringify(resultId)});
    kwaiq.page();`
  document.head.appendChild(kwaiScriptLoad)
}

function addFacebookPixel(resultId) {
  const fbqScript = document.createElement('script')
  fbqScript.type = 'text/javascript'
  fbqScript.innerHTML = `!function(f,b,e,v,n,t,s) {
      if(f.fbq) return;
      n=f.fbq=function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      };
      if(!f._fbq) f._fbq=n;
      n.push=n; n.loaded=!0; n.version='2.0';
      n.queue=[];
      t=b.createElement(e); t.async=!0;
      t.src=v;
      s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', ${JSON.stringify(resultId)});
    fbq('track', 'PageView');`
  document.head.appendChild(fbqScript)

  // noscript 标签插入到 body
  const fbqNoscript = document.createElement('noscript')
  fbqNoscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${resultId}&ev=PageView&noscript=1"/>`
  document.body.appendChild(fbqNoscript)
}

function addGoogleAnalyticsPixel(resultId) {
  // Google Analytics 4
  const gtagScript = document.createElement('script')
  gtagScript.async = true
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${resultId}`
  document.head.appendChild(gtagScript)

  // 2) 初始化
  const gtagInit = document.createElement('script')
  gtagInit.innerHTML = `window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', ${JSON.stringify(resultId)});`
  document.head.appendChild(gtagInit)

  // 第二种是google tags
  // const gtagInit = document.createElement('script')
  // gtagInit.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  //     new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  //     j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  //     'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  //     })(window,document,'script','dataLayer',"GTM-PXP59493");`
  // document.head.appendChild(gtagInit)

  //   // noscript 标签插入到 body
  // const gaNoscript = document.createElement('noscript')
  // gaNoscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PXP59493"
  //   height="0" width="0" style="display:none;visibility:hidden"></iframe>`
  // document.body.appendChild(gaNoscript)
  
}

function addTiktokPixel(resultId) {
  const ttqScript = document.createElement('script')
  ttqScript.type = 'text/javascript'
  ttqScript.innerHTML = `!function (w, d, t) {
        w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
        ttq.load(${JSON.stringify(resultId)});
        ttq.page();
        w.ttq = ttq;
      }(window, document, 'ttq');`
  document.head.appendChild(ttqScript)
}

function addDspPixel(resultId) {
  const dspScript = document.createElement('script')
  dspScript.type = 'text/javascript'
  dspScript.innerHTML = `!(function (w, d, t) {
        w.ScalerAnalyticsObject = t
        var scq = (w[t] = w[t] || {})
        scq.trigger = function(e, v) {
          scq._i.e.push({e, v})
        }
        scq.load = function (e, n) {
          var i = 'https://files.appmeta.store/files/sc-pixel.umd.js'
            ; (scq._i = scq._i || {}),
              (scq._id = e),
              (scq._i.e = [])
          var o = document.createElement('script')
            ; (o.type = 'text/javascript'),
              (o.src = i +  '?pid=' + e)
          var a = document.getElementsByTagName('script')[0]
          a.parentNode.insertBefore(o, a)
      }
      scq.load(${JSON.stringify(resultId)})
      })(window, document, 'scq')`
  document.head.appendChild(dspScript)
}

const loginAccSuccess = () => {
  
  if (loginSuccToRefresh.value) {
    location.reload();
  } else {
    router.replace("/");
  }

  showLogin.value = false;
}

EventBus.on("changePlayDomainNotication", () =>{
  const playDomain = getCachedDomain();
  videoUrl.value = playDomain;
});

EventBus.on('showLogin', (data: any) => {
  showLogin.value = true;
  loginSuccToRefresh.value = !!data.refresh;
})

EventBus.on('showSetNickName', (data: any) => {
  showSetNickName.value = true;
})

EventBus.on('getServerConfig', () => {
  const playDomain = getCachedDomain();
  videoUrl.value = playDomain;
});

EventBus.on('showAegis', (aegis) => {
  if (aegis) {
    showAegis.value = true;
    if (time.value == null) {
      time.value = setInterval(() => {
        ApiNetWork.checkAEGIS()
        console.log("去检查维护好了没");
      }, 10000)
    }
  } else {
    if (time.value) {
      time.clearInterval()
      time.value = null;
    }
    showAegis.value = false;
  }

})
EventBus.on('bgurlData', (data) => {
  // let bgurlData = { "event": 'bgurlData', 'bgurlData': data };
  videoPoster.value = data + '';
})
EventBus.on('openAd', (data) => {
  if (!!data) {
    videoAd.value = JSON.stringify(data);
  }
})

document.addEventListener("touchstart", function (event) {
  if (event.touches.length > 1) {
    event.preventDefault();
  }
});
var lastTouchEnd = 0;
document.addEventListener(
  "touchend",
  function (event) {
    var now = new Date().getTime();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  },
  false
);
document.addEventListener("gesturestart", function (event) {
  event.preventDefault();
});

// document.body.addEventListener('touchmove', function (e) {
//   e.preventDefault(); //阻止默认的处理方式(阻止下拉滑动的效果)
// }, {passive: false}); //passive 参数不能省略，用来兼容ios和android

const TJpost = () => {
  window.$apiNet.statisticsPost({ action_id: '1' });// 统计打点
  window.removeEventListener("click", TJpost)
}
window.addEventListener('click', TJpost)

window.addEventListener('message', function (e) {
  switch (e.data.event) {
    case 'changeRoomPlayer':
      changeRoomPlayer(false);
      break;
    default:
      break;
  }
}, false)





const __returned__ = { room, changeRoomPlayer, roomPlayer, ios, curversion, aegis, ConfigpiniaStore, getConfig, isData, showAegis, videoPoster, videoAd, videoUrl, time, showLogin, loginSuccToRefresh, showSetNickName, onGetPixelInfo, insertPixelScripts, addKwaiPixel, addFacebookPixel, addGoogleAnalyticsPixel, addTiktokPixel, addDspPixel, loginAccSuccess, lastTouchEnd, TJpost, layout, Popups, Ann, Login, SetNickName }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})